import React from 'react';
import ReactDOM from 'react-dom';
import { OAuth2Provider } from './providers/OAuth2Provider';
import { addValidationRule, validationRules } from 'formsy-react';
import { Http, Locale, BASE_URL, DEBUG, VARIABLE_REGEXP, SCOPE_REGEXP} from 'common';
import LOCALE from './config/locale.json';
import App from './App.jsx';


addValidationRule('isExistyVar', (values, value) => (
  value != null && value.match(VARIABLE_REGEXP)
));

addValidationRule('isVar', (values, value) => (
  !(value == null || value === '') ? value.match(VARIABLE_REGEXP) : true
));


addValidationRule('isExistyScope', (values, value) => (
  value != null && value.match(SCOPE_REGEXP)
));

addValidationRule('isScope', (values, value) => (
  !(value == null || value === '') ? value.match(SCOPE_REGEXP) : true
));

addValidationRule('isPositiveInt', (values, value) => (
  value != null && !isNaN(value) && value > 0
));


Http.configure({
  baseUrl: BASE_URL,
  debug: DEBUG
});

Locale.configure(LOCALE);

ReactDOM.render(
  (<OAuth2Provider>
    <App />
  </OAuth2Provider>),
  document.querySelectorAll('#app')[0]
);
